import { defineStore } from "pinia";
import * as _debug from "debug";
import ApiClient from "@/lib/ApiClient";
import { sureClone } from "@/lib/DataUtils";
import { createStore } from "./storeHelper";
import _ from "lodash";

const debug = _debug(`${process.env.VUE_APP_PREFIX}:CategoriesStore`);

export const useCategoriesStore = defineStore(
  "categories",
  createStore({
    state: {
      categories: {},
      editor: {},
    },

    getters: {
      categoriesList: (state) => _.values(state.categories),
      categoryById: (state) => (id) => state.categories[id],
      editorChanges() {
        return this.getEditorChanges("categories");
      },
      editorHasChanges() {
        const diff = this.editorChanges;
        return diff && !_.isEmpty(diff);
      },
    },

    actions: {
      addCategory(category) {
        this.categories[category.id] = category;
      },

      clearCategories() {
        this.categories = {};
      },

      deleteCategory(categoryId) {
        delete this.categories[categoryId];
      },

      async load() {
        debug("load");
        const categories = await ApiClient.get(`/categories`);
        debug("load", categories);
        this.set("categories", _.keyBy(categories, "id"));
      },

      async loadCategoryToEditor(categoryId) {
        debug("loadCategoryToEditor", categoryId);
        const category = this.categories[categoryId];
        if (!category) {
          throw new Error("Category not found");
        }
        this.set("editor", sureClone(category));
      },

      async saveCategoryInEditor() {
        if (!this.editorHasChanges) {
          debug("saveCategoryInEditor", "No changes to save");
          return;
        }

        const categoryId = this.editor.id;
        const result = await ApiClient.put(
          `/categories/${categoryId}`,
          this.editor,
        );

        if (result) {
          this.addCategory(result);

          // Import other stores when needed for cross-module sync
          const { useTemplatesStore } = await import("./admin/templates");
          const { useCatalogStore } = await import("./catalog");

          const templatesStore = useTemplatesStore();
          const catalogStore = useCatalogStore();

          await templatesStore.syncChangesInTarget(result);
          await catalogStore.syncChangesInTarget(result);
        }
        return result;
      },
    },
  }),
);
